import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getShippings = createAsyncThunk('shippings/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/shippings/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveShipping = createAsyncThunk('shipping/save', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const config = { headers: { 'content-type': 'multipart/form-data' } }
    const { data } = await axios.put(`/api/shippings/${t.id}/`, t, config)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const createShipping = createAsyncThunk(
  'shipping/create',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/shipping/create/', t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const deleteShipping = createAsyncThunk(
  'shipping/delete',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/shippings/${t.id}/`)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)
